(ns arthur.ui.share
  "Who is here, who may write, and who you are: the top bar's right-hand end.

  A face is also how you follow someone — see `arthur.follow`, whose lines here
  are marked.

  The same drop-down as `openmenu` — a button, a scrim, a panel — because these
  are the same kind of thing: a few rows about the document, gone on the next
  click."
  (:require [arthur.events.collab :as collab]
            [arthur.events.project :as project]
            [arthur.follow :as follow]                        ; follow
            [arthur.subs.playback :as playback]
            [clojure.string :as str]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(defn- menu
  ([label open? body] (menu label open? nil body))
  ([label open? class body]
   [:div.menu-wrap
    [:button {:class [class (when @open? "on")] :on-click #(swap! open? not)} label]
   (when @open?
     [:<> [:div.menu-scrim {:on-click #(reset! open? false)}]
      (into [:div.menu] body)])]))

(defn- initial [user] (str/upper-case (subs (or user "?") 0 1)))

(defn- face [{:keys [cid user] :as p}]
  (let [f (follow/face p)]                                    ; follow
    [:button.peer (merge {:style {:background (collab/colour cid)}
                          :aria-label (or user "guest") :title (or user "guest")
                          :disabled true}
                         f
                         {:class [(when-not user "guest") (:class f)]})
     (initial user)]))

(defn- roster []
  (let [peers @(rf/subscribe [::collab/peers])]
    (when (seq peers)
      [:span.roster
       [follow/controls]                                      ; follow
       (doall (for [p (take 5 peers)] ^{:key (:cid p)} [face p]))
       (when (< 5 (count peers))
         [:span.dim {:title (str/join ", " (map #(or (:user %) "guest") (drop 5 peers)))}
          (str "+" (- (count peers) 5))])])))

(defn- sharing []
  (r/with-let [open? (r/atom false)
               draft (r/atom "")]
    (let [{:keys [id name owner editors can-edit?]} @(rf/subscribe [::playback/project])
          {:keys [username error]} @(rf/subscribe [::collab/me])
          owner? (and owner (= owner username))
          link (str (.. js/window -location -origin) (collab/project-path id name))]
      (when id
        [menu (if (false? can-edit?) "view only ▾" "Share") open? "share-button"
         [[:h2 "link"]
          [:div.row
           [:input.share-link {:read-only true :value link :on-focus #(.select (.-target %))}]
           [:button {:on-click #(.writeText (.-clipboard js/navigator) link)} "copy"]]
          (if (false? can-edit?)
            [:<>
             [:p.dim "you can view this; to change it, make a copy of your own"]
             (when username
               [:button {:on-click (fn [] (reset! open? false)
                                     (rf/dispatch [::project/save]))}
                "make a copy"])]
            [:p.dim "anyone with the link can view"])
          (when owner
            [:<>
             [:h2 "can edit"]
             [:div.menu-item.static owner [:span.sub "owner"]]
             (doall (for [e editors]
                      ^{:key e}
                      [:div.menu-item.static e
                       (when owner?
                         [:button.link {:on-click #(rf/dispatch [::collab/remove-editor e])}
                          "remove"])]))
             (when owner?
               [:form.row {:on-submit (fn [ev]
                                        (.preventDefault ev)
                                        (when (seq (str/trim @draft))
                                          (rf/dispatch [::collab/add-editor (str/trim @draft)])
                                          (reset! draft "")))}
                [:input {:placeholder "username" :value @draft
                         :on-change #(reset! draft (.. % -target -value))}]
                [:button {:type "submit"} "add"]])
             (when error [:p.warn error])])]]))))

(defn account []
  (r/with-let [open? (r/atom false)
               username (r/atom "")
               password (r/atom "")]
    (let [{signed-in :username :keys [error]} @(rf/subscribe [::collab/me])
          go! (fn [mode] (rf/dispatch [::collab/sign-in mode @username @password])
                (reset! password ""))]
      (if signed-in
        [menu (str signed-in " ▾") open?
         [[:button.menu-item {:on-click (fn [] (reset! open? false)
                                          (rf/dispatch [::collab/sign-out]))}
           "sign out"]]]
        [menu "sign in ▾" open?
         [[:form.account {:on-submit (fn [e] (.preventDefault e) (go! :login))}
           [:input {:placeholder "username" :auto-complete "username" :value @username
                    :on-change #(reset! username (.. % -target -value))}]
           [:input {:type "password" :placeholder "password" :auto-complete "current-password"
                    :value @password :on-change #(reset! password (.. % -target -value))}]
           [:div.row
            [:button {:type "submit"} "sign in"]
            [:button {:type "button" :on-click #(go! :signup)} "create account"]]
           (when error [:p.warn error])]]]))))

(defn view []
  [:<> [roster] [sharing] [account]])
